import { Flex } from "@nulogy/components";
import React from "react";
import styled from "styled-components";
import DateTime from "utils/DateTime";
import AvailabilityCheckbox from "./AvailabilityCheckbox";
import { columnWidth } from "./WidthCalculator";

const CenteredCell = styled(Flex)(({ theme }) => ({
  alignItems: "center",
  justifyContent: "center",
  paddingBottom: theme.sizes.x2,
  paddingTop: theme.sizes.x2,
}));

export default function AvailabilityCell({ column, row }) {
  const shiftId = column.dataKey;
  const { shifts } = column.metadata;
  const col = row[shiftId];

  const formattedDate = DateTime.toISO8601Date(col.date);

  return (
    <CenteredCell height="56px" maxWidth={`${columnWidth(shifts.length)}px`}>
      <AvailabilityCheckbox
        className={`spec-availability-override-${formattedDate}`}
        data-testid={`${formattedDate}-${col.line}-${col.shift}`}
        defaultAvailability={col.defaultAvailability}
        disabled={col.disabled}
        field={`availabilities[${col.index}]['available']`}
      />
    </CenteredCell>
  );
}
